import { apiUrl }  from "../constants";
import axios from 'axios';
import middleware from '../middleware/auth';

var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':'Bearer ' + localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class EstacionesCocinaAPI {
    static getAll() {
        return middleware.hasAuth(() => request.get('/estacionCocina'));
    }

    static getByRecetasByEstacion(id) {
        return middleware.hasAuth(() => request.get(`/estacionCocina/${id}`));
    }

    static create(estacionCocina) {
        return middleware.hasAuth(() => request.post('/estacionCocina',estacionCocina));
    }

    static edit(estacionCocina){
        return middleware.hasAuth(() => request.put(`/estacionCocina`,estacionCocina));
    }

    static delete(estacionCocina){
        return middleware.hasAuth(() => request.delete(`/estacionCocina`, { data: estacionCocina }));
    }

    static agregarRecetasEstacion(estacionCocina) {
        return middleware.hasAuth(() => request.post('/estacionCocina/AgregarRecetasEstacion',estacionCocina));
    }

    static eliminarRecetasEstacion(estacionCocina) {
        return middleware.hasAuth(() => request.post('/estacionCocina/EliminarRecetasEstacion',estacionCocina));
    }

    static sincronizarEstacionesRecetas() {
        return middleware.hasAuth(() => request.post('/estacionCocina/Sync'));
    }
}